<div class="dot-container">
  <div class="snippet">
    <div class="stage">
      <div class="dot-elastic"></div>
    </div>
  </div>
</div>
